import { Component, OnInit, Input, Output, EventEmitter  } from '@angular/core';
import { Constants } from 'app/utility/constants';

@Component({
    selector: 'app-result-layout-toggle',
    templateUrl: './result-layout-toggle.component.html',
    styleUrls: ['./result-layout-toggle.component.scss'],
    standalone: false
})
export class ResultLayoutToggleComponent implements OnInit {

	constructor() { }

	@Input() value: ResultLayoutToggleType = "list";
	@Output() valueChanged: EventEmitter<ResultLayoutToggleType> = new EventEmitter<ResultLayoutToggleType>();
	display:boolean = true;
	ngOnInit() {
		if (window.innerWidth<767) {
			this.display = false;
			this.value = "list"
			this.valueChanged.emit("list");
		}
		else if (!value) {
			var resultLayout = localStorage.getItem(Constants.LocalStorage_ResultLayout);
			if (resultLayout) {
				var value = resultLayout=="list"?"list":"grid";
				this.setValue(value);
			}
			else {
				this.value = "grid"
				localStorage.setItem(Constants.LocalStorage_ResultLayout, this.value);
				this.valueChanged.emit(this.value);
			}
		}
	}

	private setValue(value: string)
	{
		if (this.value != value)
		{
			this.valueChanged.emit(this.value);
		}
	}

	segmentChanged(ev:any) {
		this.value = ev.detail.value;
		localStorage.setItem(Constants.LocalStorage_ResultLayout, this.value);
		this.valueChanged.emit(this.value);
	}
}

export type ResultLayoutToggleType = 'list' | 'grid' ;